import attachmentSaveEpic from './attachment-save-epic';

export default attachmentSaveEpic;
